var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2121 12.2208L15.4307 10.6499C15.4979 10.1666 15.5594 9.72475 15.6141 9.31944C15.7264 8.48652 15.7826 8.07005 15.5335 7.78519C15.2845 7.50033 14.8565 7.50033 14.0005 7.50033H5.99888C5.14286 7.50033 4.71485 7.50033 4.46582 7.78519C4.21679 8.07005 4.27295 8.48652 4.38528 9.31944C4.43995 9.72487 4.5014 10.1664 4.56868 10.6499L4.7873 12.2208C5.02489 13.928 5.14369 14.7817 5.39559 15.4673C5.86663 16.7493 6.68087 17.7042 7.65272 18.1144C8.17243 18.3337 8.78152 18.3337 9.99968 18.3337C11.2178 18.3337 11.8269 18.3337 12.3466 18.1144C13.3185 17.7042 14.1327 16.7493 14.6038 15.4673C14.8557 14.7817 14.9745 13.928 15.2121 12.2208ZM8.95801 9.16699C8.95801 8.82181 8.67819 8.54199 8.33301 8.54199C7.98783 8.54199 7.70801 8.82181 7.70801 9.16699V15.8337C7.70801 16.1788 7.98783 16.4587 8.33301 16.4587C8.67819 16.4587 8.95801 16.1788 8.95801 15.8337V9.16699ZM12.2913 9.16699C12.2913 8.82181 12.0115 8.54199 11.6663 8.54199C11.3212 8.54199 11.0413 8.82181 11.0413 9.16699V15.8337C11.0413 16.1788 11.3212 16.4587 11.6663 16.4587C12.0115 16.4587 12.2913 16.1788 12.2913 15.8337V9.16699Z",
    fill: "#001F06"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 1.04199C7.81355 1.04199 6.04134 2.8142 6.04134 5.00033V5.20866H3.33301C2.98783 5.20866 2.70801 5.48848 2.70801 5.83366C2.70801 6.17884 2.98783 6.45866 3.33301 6.45866H16.6663C17.0115 6.45866 17.2913 6.17884 17.2913 5.83366C17.2913 5.48848 17.0115 5.20866 16.6663 5.20866H13.958V5.00033C13.958 2.8142 12.1858 1.04199 9.99967 1.04199Z",
    fill: "#001F06"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.81ca50e6ff3482fd64e038c33ce4f9b8.svg";
export { ForwardRef as ReactComponent };